/**
 * Copyright 2025 (c) Karsten Röthig, FVA GmbH (for umati and VDW e.V.)
 */
import React, { ReactElement } from 'react';
import { Section, UaPlaceholder } from 'templates/pubSub/types/TemplateType';
import { TemplateContext } from 'templates/pubSub/types/TemplateContextType';
import { usePubSubNode, usePubSubNodes } from 'utilities/PubSub/PubSubHooks';
import TemplateHelperPubSub from 'utilities/TemplateHelperPubSub';
import { NodeIdentifier } from 'utilities/PubSub/PubSubAddressSpace';
import SectionAccordionCard from './SectionAccordionCard';

interface ISectionAccordionCardPlaceholderProps {
  templateContext: TemplateContext;
  section: Section;
  placeholder: UaPlaceholder;
  placeholderIndex: number;
  startingNodeId?: NodeIdentifier;
}

export default function SectionAccordionCardPlaceholder(props: ISectionAccordionCardPlaceholderProps): ReactElement {
  const filter = TemplateHelperPubSub.createFilter(props.templateContext.namespaces, props.placeholder.variablePath);
  const node = usePubSubNode(filter, props.startingNodeId);
  const placeholderFilter = TemplateHelperPubSub.createReferenceAndTypeFilter(
    props.templateContext.namespaces,
    props.placeholder.reference,
    props.placeholder.type,
  );
  const placeholderNodes = usePubSubNodes(placeholderFilter, node);

  const nextPlaceholder =
    props.section.placeholders && props.section.placeholders.length > props.placeholderIndex + 1
      ? props.section.placeholders[props.placeholderIndex + 1]
      : undefined;

  return (
    <>
      {placeholderNodes.map((placeholderNode, placeholderNodeIndex) => (
        <>
          {nextPlaceholder ? (
            <SectionAccordionCardPlaceholder
              key={TemplateHelperPubSub.getPlaceholderObjectKey(props.section.id, placeholderNodeIndex)}
              templateContext={props.templateContext}
              section={props.section}
              placeholder={nextPlaceholder}
              placeholderIndex={props.placeholderIndex + 1}
              startingNodeId={placeholderNode}
            />
          ) : (
            <SectionAccordionCard
              templateContext={props.templateContext}
              eventKey={props.section.id}
              section={props.section}
              startingNodeId={placeholderNode}
            />
          )}
        </>
      ))}
    </>
  );
}
